import { ImageName } from '../../../../../shared/components/svg-image/images';
import { Area } from '../../../../../shared/helpers/layout-manager/types';
import { safeDrawMedia } from './draw-helpers';
import { getIconImage } from './draw-images';

const ICON_SPACE = 8;
const ICON_SIZE = 24;
const ICON_COLOR = 'rgba(255, 255, 255, 0.4)';
const ICON_BACKGROUND_COLOR = '#131317';
const ICON_BORDER_RADIUS = 6;

export const drawParticipantStatuses = (ctx: CanvasRenderingContext2D, area: Area, statusIcons: ImageName[]) => {
    for (let i = 0; i < statusIcons.length; i++) {
        const iconArea = {
            x: area.x + ICON_SPACE + (ICON_SIZE + ICON_SPACE / 2) * i,
            y: area.y + ICON_SPACE,
            width: ICON_SIZE,
            height: ICON_SIZE,
        };
        const imageName = statusIcons[i];
        safeDrawMedia(
            ctx,
            iconArea,
            getIconImage({
                name: imageName,
                iconColor: ICON_COLOR,
                backgroundColor: ICON_BACKGROUND_COLOR,
                borderRadius: ICON_BORDER_RADIUS,
            }),
            {
                mode: 'contain',
            }
        );
    }
};
